import React from 'react'
import ServiceDetail from '../components/service-detail'
import ServiceData from '../components/service-data'
// import ComingSoon from '../components/comingSoon';
import usePageMeta from '../hooks/usePageMeta';

export default function Service() {
    usePageMeta('Our Digital Services | Web Design, Dev & CRO | Spinnennetz', 'Explore our comprehensive digital services, including custom web design, CMS development, e-commerce solutions, and AI-driven conversion rate optimization.', '/service', {"@context":"https://schema.org","@type":"Service","name":"Digital Services","provider":{"@type":"Organization","name":"Spinnennetz"}});
    return (
        <>
            {<ServiceDetail />}
            {<ServiceData />}
            {/* <ComingSoon /> */}
        </>
    );
}
